import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-contents" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_6 = { class: "input-group top_search" };
const _hoisted_7 = { class: "input-group-btn" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_9 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_10 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_13 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_14 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_15 = { class: "float-end" };
const _hoisted_16 = { class: "float-end hidden-xs record-count" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12" };
const _hoisted_18 = { class: "card bg-white data-grid smtp-importer-logs-grid detached overflow-x-auto" };
const _hoisted_19 = {
    id: "logsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_20 = { class: "date-time-column" };
const _hoisted_21 = { class: "hidden-sm" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "hidden-sm" };
const _hoisted_24 = { class: "clearfix visible-sm" };
const _hoisted_25 = { class: "hidden-sm" };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { class: "clearfix" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = { class: "d-flex align-items-center gap-2" };
const _hoisted_30 = { class: "col-xs-12 col-sm-12" };
const _hoisted_31 = { class: "card bg-white data-grid smtp-import-log-detail-grid detached overflow-x-auto" };
const _hoisted_32 = {
    id: "emailLogsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { key: 1 };
const _hoisted_35 = { class: "d-flex align-items-center gap-2" };
const _hoisted_36 = { class: "col-xs-12 col-sm-12" };
const _hoisted_37 = { class: "card bg-white data-grid smtp-import-log-detail-grid detached overflow-x-auto" };
const _hoisted_38 = {
    id: "emailLogsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = { key: 0 };
const _hoisted_41 = { key: 2 };
const _hoisted_42 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_43 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_44 = { class: "float-end" };
const _hoisted_45 = { class: "float-end hidden-xs record-count" };
const _hoisted_46 = { class: "col-xs-12 col-sm-12" };
const _hoisted_47 = { class: "card bg-white data-grid smtp-import-log-detail-grid detached overflow-x-auto" };
const _hoisted_48 = {
    id: "emailLogsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_49 = { class: "date-time-column" };
const _hoisted_50 = ["onClick"];
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[80] || (_cache[80] = _createElementVNode("div", { class: "form-details" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tSMTP Importer Logs\r\n\t\t\t\t")
            ])
        ], -1 /* CACHED */)),
        _cache[81] || (_cache[81] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_7, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_8, [
                        (!_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_b_button, {
                                        class: "pw100",
                                        disabled: _ctx.working,
                                        key: idx,
                                        variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                        onClick: ($event) => (_ctx.setDateFilterOption(item))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[18] || (_cache[18] = _createTextVNode()),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedFrom,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.whenCreatedFrom) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "From date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                        _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                class: "btn btn-default",
                                                                "data-toggle": ""
                                                            }, [
                                                                _createElementVNode("i", { class: "fa fa-calendar" })
                                                            ])
                                                        ], -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ]),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_b_input_group, {
                                        class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                class: "form-control",
                                                modelValue: _ctx.query.whenCreatedTo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.whenCreatedTo) = $event)),
                                                config: _ctx.datePickerConfig,
                                                placeholder: "Until date",
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[16] || (_cache[16] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                                default: _withCtx(() => [
                                                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-default",
                                                            "data-toggle": ""
                                                        }, [
                                                            _createElementVNode("i", { class: "fa fa-calendar" })
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn-secondary",
                                                        onClick: _cache[4] || (_cache[4] =
                                                            //@ts-ignore
                                                            (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                    }, "\r\n\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[27] || (_cache[27] = _createTextVNode()),
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */)),
                _cache[29] || (_cache[29] = _createTextVNode()),
                (_ctx.searchAttempted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ]),
                            _cache[20] || (_cache[20] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_16, "\r\n\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[30] || (_cache[30] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("table", _hoisted_19, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_20, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'whenCreated', title: 'Time', visible: true }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ]),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_21, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'status', title: 'Status' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: "pointer",
                                        onClick: ($event) => (_ctx.view(item))
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatTimeString(item.whenCreated)), 1 /* TEXT */),
                                            _cache[22] || (_cache[22] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getSMTPImporterStatusText(item.status)), 1 /* TEXT */)
                                        ]),
                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.getSMTPImporterStatusText(item.status)), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_22));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[26] || (_cache[26] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [...(_cache[24] || (_cache[24] = [
                                            _createElementVNode("td", {
                                                class: "text-center hidden-sm",
                                                colspan: "13"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */),
                                            _createTextVNode(),
                                            _createElementVNode("td", { class: "text-center visible-sm" }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ]),
        _cache[82] || (_cache[82] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "smtp-importer-log-details-popup",
            modelValue: _ctx.viewingLogDetails,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.viewingLogDetails) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("\r\n\t\t\t\tLog Details\r\n\t\t\t", -1 /* CACHED */)
                ]))]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[78] || (_cache[78] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, [
                            (_ctx.showMessagesModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("i", {
                                            class: "fa fa-arrow-left font16 pointer",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.selectedFile = null))
                                        }),
                                        _cache[32] || (_cache[32] = _createTextVNode()),
                                        _cache[33] || (_cache[33] = _createElementVNode("h2", null, "Messages", -1 /* CACHED */))
                                    ]),
                                    _cache[40] || (_cache[40] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("table", _hoisted_32, [
                                                _cache[37] || (_cache[37] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tType\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tMessage\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tException\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ])
                                                ], -1 /* CACHED */)),
                                                _cache[38] || (_cache[38] = _createTextVNode()),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMessagesToDisplay(), (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", null, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getMesssageTypeText(item.messageType)), 1 /* TEXT */),
                                                            _cache[34] || (_cache[34] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.message), 1 /* TEXT */),
                                                            _cache[35] || (_cache[35] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.errorException), 1 /* TEXT */)
                                                        ]));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _cache[39] || (_cache[39] = _createTextVNode()),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.getMessagesToDisplay().length == 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [...(_cache[36] || (_cache[36] = [
                                                                _createElementVNode("td", {
                                                                    class: "text-center",
                                                                    colspan: "3"
                                                                }, [
                                                                    _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ], -1 /* CACHED */)
                                                            ]))]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[75] || (_cache[75] = _createTextVNode()),
                            (_ctx.showFilesModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("i", {
                                            class: "fa fa-arrow-left font16 pointer",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.selectedEmail = null))
                                        }),
                                        _cache[41] || (_cache[41] = _createTextVNode()),
                                        _cache[42] || (_cache[42] = _createElementVNode("h2", null, "Files Attached", -1 /* CACHED */))
                                    ]),
                                    _cache[55] || (_cache[55] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("table", _hoisted_38, [
                                                _cache[52] || (_cache[52] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tStatus\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAttached File Name\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tFile Name\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tErrors\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tWarnings\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSystems\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSnapshots\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tCharges\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                        _createTextVNode(),
                                                        _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tDischarges\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ])
                                                ], -1 /* CACHED */)),
                                                _cache[53] || (_cache[53] = _createTextVNode()),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilesToDisplay(), (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            class: "pointer",
                                                            onClick: _withModifiers(($event) => (_ctx.selectFile(item)), ["stop"])
                                                        }, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getStatusText(item.status)), 1 /* TEXT */),
                                                            _cache[43] || (_cache[43] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.attachedFileName), 1 /* TEXT */),
                                                            _cache[44] || (_cache[44] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.fileName), 1 /* TEXT */),
                                                            _cache[45] || (_cache[45] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithError), 1 /* TEXT */),
                                                            _cache[46] || (_cache[46] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithWarning), 1 /* TEXT */),
                                                            _cache[47] || (_cache[47] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfSystemsImported), 1 /* TEXT */),
                                                            _cache[48] || (_cache[48] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfSnapshotsImported), 1 /* TEXT */),
                                                            _cache[49] || (_cache[49] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfChargeImported), 1 /* TEXT */),
                                                            _cache[50] || (_cache[50] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfDischargeImported), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_39));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _cache[54] || (_cache[54] = _createTextVNode()),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.getFilesToDisplay().length == 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [...(_cache[51] || (_cache[51] = [
                                                                _createElementVNode("td", {
                                                                    class: "text-center",
                                                                    colspan: "9"
                                                                }, [
                                                                    _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ], -1 /* CACHED */)
                                                            ]))]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[76] || (_cache[76] = _createTextVNode()),
                            (_ctx.showEmailsModal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _cache[72] || (_cache[72] = _createElementVNode("h2", null, "Emails", -1 /* CACHED */)),
                                    _cache[73] || (_cache[73] = _createTextVNode()),
                                    (_ctx.searchAttempted)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, [
                                                    _createVNode(_component_b_pagination, {
                                                        class: "float-end",
                                                        modelValue: _ctx.detailsQuery.pageNo,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.detailsQuery.pageNo) = $event)),
                                                        "per-page": _ctx.detailsQuery.pageSize,
                                                        "total-rows": _ctx.logDetails.emails.recordCount,
                                                        "hide-ellipsis": true,
                                                        disabled: _ctx.working
                                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                                ]),
                                                _cache[56] || (_cache[56] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_45, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.logDetails.emails.recordCount), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[74] || (_cache[74] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("table", _hoisted_48, [
                                                _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", _hoisted_49, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'messageDateTime', title: 'Time', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[57] || (_cache[57] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'status', title: 'Status', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[58] || (_cache[58] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'from', title: 'From', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[59] || (_cache[59] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'subject', title: 'Subject', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[60] || (_cache[60] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'numberOfFilesAttached', title: 'Attachments', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[61] || (_cache[61] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'numberOfFilesWithError', title: 'Errors', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[62] || (_cache[62] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.detailsSorter,
                                                                column: { fieldName: 'numberOfFilesWithWarning', title: 'Warnings', visible: true }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ])
                                                    ])
                                                ]),
                                                _cache[70] || (_cache[70] = _createTextVNode()),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logDetails.emails.records, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            class: "pointer",
                                                            onClick: ($event) => (_ctx.selectEmail(item))
                                                        }, [
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.formatTimeString(item.messageDateTime)), 1 /* TEXT */),
                                                            _cache[63] || (_cache[63] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(_ctx.getStatusText(item.status)), 1 /* TEXT */),
                                                            _cache[64] || (_cache[64] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.from), 1 /* TEXT */),
                                                            _cache[65] || (_cache[65] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.subject), 1 /* TEXT */),
                                                            _cache[66] || (_cache[66] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesAttached), 1 /* TEXT */),
                                                            _cache[67] || (_cache[67] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithError), 1 /* TEXT */),
                                                            _cache[68] || (_cache[68] = _createTextVNode()),
                                                            _createElementVNode("td", null, _toDisplayString(item.numberOfFilesWithWarning), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_50));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _cache[71] || (_cache[71] = _createTextVNode()),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.logDetails.emails.length == 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [...(_cache[69] || (_cache[69] = [
                                                                _createElementVNode("td", {
                                                                    class: "text-center",
                                                                    colspan: "7"
                                                                }, [
                                                                    _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ], -1 /* CACHED */)
                                                            ]))]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[79] || (_cache[79] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _cache[83] || (_cache[83] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.loading,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
